// extracted by mini-css-extract-plugin
module.exports = {"column":"RecoveryCode_column__199dt","buttonWrapper":"RecoveryCode_buttonWrapper__1e1Ms"};